import ReactQuill from 'react-quill';
import { useEffect, forwardRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import FormHelperText from '@mui/material/FormHelperText';

import Label from 'src/components/label';

import Editor, { EditorProps } from '../editor';

// ----------------------------------------------------------------------

interface Props extends EditorProps {
  name: string;
  label?: string | undefined;
  disabled?: boolean;
}

const RHFEditor = forwardRef<ReactQuill, Props>(({ name, label, helperText, disabled, ...other }, ref) => {
  const {
    control,
    watch,
    setValue,
    formState: { isSubmitSuccessful },
  } = useFormContext();

  const values = watch();

  useEffect(() => {
    if (values[name] === '<p><br></p>') {
      setValue(name, '', {
        shouldValidate: !isSubmitSuccessful,
      });
    }
  }, [isSubmitSuccessful, name, setValue, values]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div style={{ position: 'relative' }}>
          {label && (
            <Label
              style={{
                position: 'absolute',
                background: 'white',
                zIndex: 20,
                top: -12,
                left: 8,
                fontWeight: 600,
              }}
            >
              {label}
            </Label>
          )}
          <Editor
            ref={ref}
            id={name}
            value={field.value}
            disabled={disabled}
            onChange={field.onChange}
            error={!!error}
            
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2 }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            {...other}
          />
        </div>
      )}
    />
  );
});

RHFEditor.displayName = 'RHFEditor';

export default RHFEditor;
